import React from "react";
import { Link } from "react-router-dom";
import CollectionC from "../components/CollectionC";
import LeftC from "../components/LeftC";
import MenCasual from "../components/products/mens/MenCasual";
import MenSuit from "../components/products/mens/MenSuit";
import RightC from "../components/RightC";
import SliderC from "../components/SliderC";
import CircularDemo from "./SecSlider";

const MainPage = () => {
  return (
    <div className="main-section">
      <div className="slider">
        <SliderC />
      </div>
      <CircularDemo />
      <div className="sec-title">Top Categories</div>
      <div className="display-cards mob-cards">
        <div className="ind-card-menu">
          <ul>
            <Link to="/mens">
              <li>Men</li>
            </Link>
            <Link to="/woman">
              <li>Woman</li>
            </Link>

            <li>Children</li>

            <li>Party Wear</li>
          </ul>
        </div>
        <div className="ind-card">
          <Link to="/mens">
            <img src="assets/Cards/categ-1.jpg" alt="" />
          </Link>
        </div>
        <div className="ind-card">
          <Link to="/woman">
            <img src="assets/Cards/categ-2.jpg" alt="" />
          </Link>
        </div>
        <div className="ind-card">
          <Link to="/woman">
            <img src="assets/Cards/categ-3.jpg" alt="" />
          </Link>
        </div>
        <div className="ind-card">
          <Link to="/mens">
            <img src="assets/Cards/categ-4.jpg" alt="" />
          </Link>
        </div>
      </div>

      <div className="two-sec tab-view">
        <div className="ind-parts">
          <Link to="mens">
            <img src="assets/Hero/part-10.jpg" alt="" />
          </Link>
        </div>
        <div className="ind-parts">
          <Link to="/woman">
            <img src="assets/Hero/part-11.jpg" alt="" />
          </Link>
        </div>
      </div>
      <div className="sec-title mob-sec-title">Top Deals In</div>

      <div className="bricks-sec">
        <div className="ind-brick">
          <img src="assets/Hero/brick-1.jpg" alt="" />
        </div>
        <div className="ind-brick">
          <img src="assets/Hero/brick-2.jpg" alt="" />
        </div>
        <div className="ind-brick">
          <img src="assets/Hero/brick-3.jpg" alt="" />
        </div>
        <div className="ind-brick">
          <img src="assets/Hero/brick-4.jpg" alt="" />
        </div>
        <div className="ind-brick">
          <img src="assets/Hero/brick-5.jpg" alt="" />
        </div>
        <div className="ind-brick">
          <img src="assets/Hero/brick-6.jpg" alt="" />
        </div>
        <div className="ind-brick">
          <img src="assets/Hero/brick-7.jpg" alt="" />
        </div>
        <div className="ind-brick">
          <img src="assets/Hero/brick-8.jpg" alt="" />
        </div>
        <div className="ind-brick">
          <img src="assets/Hero/brick-9.jpg" alt="" />
        </div>
        <div className="ind-brick">
          <img src="assets/Hero/brick-10.jpg" alt="" />
        </div>
      </div>
      <div className="sec-title">New Styles For You</div>
      <div className="two-sec mob-brick">
        <div className="ind-parts">
          <Link to="/woman">
            <img src="assets/Hero/part-12.jpg" alt="" />
          </Link>
        </div>
        <div className="ind-parts">
          <Link to="/woman">
            <img src="assets/Hero/part-13.jpg" alt="" />
          </Link>
        </div>
        <div className="ind-parts">
          <Link to="/mens">
            <img src="assets/Hero/part-14.jpg" alt="" />
          </Link>
        </div>
        <div className="ind-parts">
          <Link to="/woman">
            <img src="assets/Hero/part-15.jpg" alt="" />
          </Link>
        </div>
      </div>

      <div className="content-sec">
        <div className="left-sec">{/* <LeftC /> */}</div>
        <div className="collection-sec">{/* <MenSuit />           */}</div>
        <div className="right-sec">{/* <RightC /> */}</div>
      </div>
    </div>
  );
};

export default MainPage;
